module.exports = __webpack_public_path__ + "static/media/tour-popup-2-fig.d5fa03e5.png";